import { Notice } from '../../Model/Notice';
import { NoticeRepository } from '../Repositories/NoticeRepository';

export class GetNoticesUseCase {
  constructor(private repo: NoticeRepository) {}
  execute(): Promise<Notice[]> {
    return this.repo.list().then(r => r).catch(err => Promise.reject(err));
  }
}
